import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

let PageComponent = false;
let ApplyPageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  PageComponent = require('./franchise_page').default;
  // eslint-disable-next-line global-require
  ApplyPageComponent = require('./franchise_apply_page').default;
}

export function franchiseApplyPage(store) {
  const routeConfig = {
    path: '/apply/:slug(next-big-things-in-tech)',
    component() {
      if (ApplyPageComponent) {
        return <ApplyPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    // autoScrollOff: true,
    loadData: ApplyPageComponent
      ? ApplyPageComponent.loadData(store, false, {
          type: 'application'
        })
      : false,
    preloadChunk() {
      return import('./franchise_apply_page').then(resp => {
        ApplyPageComponent = resp.default;
        routeConfig.loadData = ApplyPageComponent.loadData(store, false, {
          type: 'application'
        });

        return ApplyPageComponent;
      });
    },
    chunk: 'franchisePage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function franchisePage(store) {
  const routeConfig = {
    path: '/:slug(amazon-taking-over-complete-guide|next-big-things-in-tech)',
    component() {
      if (PageComponent) {
        return <PageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    // autoScrollOff: true,
    loadData: PageComponent ? PageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./franchise_page').then(resp => {
        PageComponent = resp.default;
        routeConfig.loadData = PageComponent.loadData(store);

        return PageComponent;
      });
    },
    chunk: 'franchisePage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
